import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { SiteLockProvider } from './context/SiteLockContext';
import { LanguageProvider } from './context/LanguageContext';
import { ThemeProvider } from './context/ThemeContext';
import { ViewProvider } from './context/ViewContext';
import { MainLayout } from './components/layout/MainLayout';
import { NotificationPopup } from './components/notifications/NotificationPopup';
import LoginPage from './pages/LoginPage';
import WikiPage from './pages/WikiPage';
import AdminPage from './pages/AdminPage';
import ReportsPage from './pages/ReportsPage';
import DashboardPage from './pages/DashboardPage';
import MetaPage from './pages/MetaPage';
import TimerPage from './pages/TimerPage';
import CodesPage from './pages/CodesPage';
import './App.css';

function App() {
    return (
        <ThemeProvider>
            <LanguageProvider>
                <ViewProvider>
                    <AuthProvider>
                        <SiteLockProvider>
                            <BrowserRouter>
                                <Routes>
                                    {/* Public route */}
                                    <Route path="/login" element={<LoginPage />} />
                                    
                                    {/* Protected routes */}
                                    <Route element={<MainLayout />}>
                                        <Route path="/" element={<DashboardPage />} />
                                        <Route path="/dashboard" element={<DashboardPage />} />
                                        <Route path="/admin" element={<AdminPage />} />
                                        <Route path="/reports" element={<ReportsPage />} />
                                        <Route path="/meta" element={<MetaPage />} />
                                        <Route path="/timers" element={<TimerPage />} />
					<Route path="/codes" element={<CodesPage />} />
                                        <Route path="/relics" element={<WikiPage />} />
                                        <Route path="/relics/:id" element={<WikiPage />} />
                                        <Route path="/accessories" element={<WikiPage />} />
                                        <Route path="/accessories/:id" element={<WikiPage />} />
                                        <Route path="/skills" element={<WikiPage />} />
                                        <Route path="/skills/:id" element={<WikiPage />} />
                                        <Route path="/gachas" element={<WikiPage />} />
                                        <Route path="/gachas/:id" element={<WikiPage />} />
                                        <Route path="/upgrades" element={<WikiPage />} />
                                        <Route path="/upgrades/:id" element={<WikiPage />} />
                                        <Route path="/achievements" element={<WikiPage />} />
                                        <Route path="/achievements/:id" element={<WikiPage />} />
                                        <Route path="/tutorials" element={<WikiPage />} />
                                        <Route path="/tutorials/:id" element={<WikiPage />} />
                                    </Route>

                                    {/* Catch all */}
                                    <Route path="*" element={<Navigate to="/" replace />} />
                                </Routes>
                                <NotificationPopup />
                            </BrowserRouter>
                        </SiteLockProvider>
                    </AuthProvider>
                </ViewProvider>
            </LanguageProvider>
        </ThemeProvider>
    );
}

export default App;
